import { render } from "./SidebarPerfil.vue?vue&type=template&id=01cf8c80&scoped=true"
import script from "./SidebarPerfil.vue?vue&type=script&lang=js"
export * from "./SidebarPerfil.vue?vue&type=script&lang=js"

import "./SidebarPerfil.vue?vue&type=style&index=0&id=01cf8c80&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01cf8c80"]])

export default __exports__